<div class="outer-container col-lg-12">
  <div class="inner-container">
    <div class="centered-message">
      <div role="alert" class="alert alert-{{type}} notification-message">
        {{ message | translate }}
      </div>
    </div>
  </div>
</div>
